export enum ConnectionStatusEnum {
    Connected = 'connected',
    Disconnected = 'disconnected',
    Connecting = 'connecting',
}
